import React, { useState, useEffect } from 'react';
import { useForm, useFormState } from "react-hook-form";

import FormInput from '../form-input/form-input.component';
import VoucherResults from '../voucher-results/voucher-results.component';

import Slider from '../slider/slider.component';
import { getVoucher } from '../../app.service';

// 

import './voucher-form.styles.scss';
import axios from 'axios';

const VoucherFormComponent = () => {

const [voucherStatus, setVoucherStatus] = useState('');
const [voucherRes, setVoucherRes] = useState([]);
const [touched, setTouched] = useState({});

const [values, setValues] = useState({
    email: '',
    password: '',
    upsSerial: '',
    voucher: ''
});


const [saving, setSaving] = useState(false);
const [loading, setLoading] = useState(false);

const handleSubmit = async (e) => {

    console.log("touched", touched)

    e.preventDefault();

    //console.log("e",e)

    const { email, password, upsSerial, voucher } = values;
    const voucherInfo = {email, password, upsSerial, voucher};

    // const { email, password, voucher } = values;
    // const voucherInfo = {email, password, voucher};
    
    setSaving(true);
   await axios.post(`${getVoucher()}`, voucherInfo)
    .then(res => {
        console.log("res", res)
        if(res.data.result === 'VoucherAlreadyRedeemed'){
            // setVoucherRes(res.data.result)
            setVoucherRes("Voucher has been redeemed already.");
        }else if(res.data.result === 'VoucherNotValid'){
            setVoucherRes("Voucher is not valid. Please check your input and if not successful contact support number or email below.");
            // setVoucherRes(res.data.result);
            //console.log("status", voucherStatus)
        }else if(res.data.result === 'VoucherInfoNotFound'){
            setVoucherRes("Voucher information cannot be found. Please check your input and if not successful contact support number or email below.")
            // setVoucherRes(res.data.result)
        }else{
             //setVoucherStatus("VoucherInfoFound");
             setVoucherRes(res.data)
             setVoucherStatus("VoucherInfoFound");
             console.log("res", res.data)
             
        }
    }) 
    .catch((error) => {
        console.log("error", error)
        setVoucherStatus("Voucher information not found. Please check your input and if not successful contact support number or email below.");
        console.log("-------", voucherStatus)
    })      
};

const handleChange = name => e => {
    setValues({ ...values, [name]: e.target.value });
    setSaving(false);
    setVoucherRes('');
        // was the field modified
    setTouched({
        ...touched,
        [name]: true,
        });

    console.log("name", e.target.value, touched)
};

const showLoading = () => (loading ? <div className="alert alert-info">Loading...</div> : '');

if(voucherRes.length === 0 || typeof voucherRes !== 'object'){
    return (
        
      
        <div className='voucherForm'>
            
                <Slider/>
          
            <h2 className='title'>Redeem your voucher</h2>
            {/* 
            <span>Sign up with your email and password</span> */}
            <form className='sign-up-form' onSubmit={handleSubmit}>
                <div className="row">
                    <div className="column">
                        <FormInput
                            type='email'
                            name='email'
                            value={values.email}
                            onChange={handleChange('email')}
                            label='Email' />
                        <p className='validate'>{touched.email === true && values.email === '' ? "Please input a valid email address" : ''}</p>
                    </div>
                    <div className="column">
                        <FormInput
                            type='voucher'
                            name='voucher'
                            value={values.voucher}
                            onChange={handleChange('voucher')}
                            label='Voucher'
                            required />
                        <p className='validate'>{touched.voucher === true && values.voucher === '' ? "Please input a voucher" : ''}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="column">
                        <FormInput
                            type='upsSerial'
                            name='upsSerial'
                            value={values.upsSerial}
                            onChange={handleChange('upsSerial')}
                            label='UPS Serial No.'
                            required />
                        <p className='validate'>{touched.upsSerial === true && values.upsSerial === '' ? "Please input a ups serial" : ''}</p>
                    </div>
                    <div className="column">
                        <FormInput
                            type='text'
                            name='text'
                            value={values.password}
                            onChange={handleChange('password')}
                            label='Password'
                            required />
                        <p className='validate'>{touched.password === true && values.password === '' ? "Please input a password" : ''}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="column">
                    </div>
                    <div className="column">
                        {
                    typeof voucherRes !== 'object' && voucherRes !== '' ? voucherRes:
                    saving === true ? <h2> Checking...</h2> : <button type='submit'> SUBMIT </button>
                    } 
                    </div>
                </div>
                
                              
            </form>

            <br/>
            {/* <h3 className='status'>{typeof voucherRes !== 'object' ? voucherRes : ''}</h3> */}
        </div>
    )
}else {
    return (
    <div><VoucherResults voucherRes={voucherRes}/></div>
    )

}

}

export default VoucherFormComponent;
